import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    }
    return String(detail);
}

export function trackEvent(event, meta = {}) {
    api.post("/analytics/event", {
        event,
        path: typeof window !== "undefined" ? window.location.pathname : null,
        meta,
    }).catch(() => {});
}

export const STATES = [
    { code: "NSW", label: "New South Wales" },
    { code: "VIC", label: "Victoria" },
    { code: "QLD", label: "Queensland" },
    { code: "WA", label: "Western Australia" },
    { code: "SA", label: "South Australia" },
    { code: "TAS", label: "Tasmania" },
    { code: "ACT", label: "Australian Capital Territory" },
    { code: "NT", label: "Northern Territory" },
];

export const CHILDCARE_TYPES = [
    { value: "long_day_care", label: "Long Day Care" },
    { value: "family_day_care", label: "Family Day Care" },
    { value: "outside_school_hours_care", label: "Outside School Hours Care" },
];

export const CHILD_ORDERS = [
    { value: "first", label: "First child" },
    { value: "second", label: "Second child" },
    { value: "third_or_more", label: "Third or more" },
];

export const formatAUD = (n) =>
    new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 }).format(Number(n) || 0);

export const formatAUDc = (n) =>
    new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 }).format(Number(n) || 0);
